import { render, staticRenderFns } from "./MessageDialogue.vue?vue&type=template&id=2003999f&"
import script from "./MessageDialogue.vue?vue&type=script&lang=ts&"
export * from "./MessageDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports